<template>
    <div class="Schedule" v-if="lang">
        <md-whiteframe class="shadow shadow-faint">
            <div class="search search--field">
                <div class="icon">
                    <md-icon>search</md-icon>
                </div>
                <div class="input">
                    <input type="text" v-model="search.query" placeholder="Buscar horarios" style="outline:0;">
                    <span class="status">{{ searchIndicator }}</span>
                </div>
            </div>
        </md-whiteframe>
        <div class="table table--office table-mobile table--schedule">
            <md-table-card v-if="offices.length > 0" class="table--wrap">
                <md-table md-sort="name" @sort="onSort" md-sort-by="name">
                    <md-table-header>
                        <md-table-row>
                            <md-table-head class="td-sort-name center-mobile" md-sort-by="name">{{ translate.pages.schedule.index.fields.name }}</md-table-head>
                            <md-table-head class="hidden-mobile" md-sort-by="street">{{ translate.pages.schedule.index.fields.address }}</md-table-head>
                            <md-table-head class="hidden-mobile">{{ translate.pages.schedule.index.fields.days }}</md-table-head>
                        </md-table-row>
                    </md-table-header>
                    <md-table-body>
                        <md-table-row v-for="(row, rowIndex) in offices" :key="rowIndex" :md-item="row">
                            <md-table-cell class="name--cell">
                                <div class="img">
                                    <img :src="srcImage(row.path)">
                                </div>
                                <span class="name">{{ row.name }}</span>
                                <span class="subname visible-mobile">{{ row.street }} {{ row.number }}, {{row.comunity}}</span>
                            </md-table-cell>
                            <md-table-cell class="hidden-mobile">
                                <span>{{ row.street }} {{ row.number }}, {{row.comunity}}</span>
                            </md-table-cell>
                            <md-table-cell class="schedule-detail">
                                <span v-if="row.schedules.length > 0">{{ row.schedules[0].turns_active | formatDays }}</span>
                                <span v-else>{{ translate.pages.schedule.index.timeNoDefined }}</span>
                                <router-link :to="{ name: 'ScheduleDetail', params: { officeId: row.id } }" class="icon-detail icon-schedule">
                                    <i class="md-icon icon-detail md-theme-default material-icons">keyboard_arrow_right</i>
                                </router-link>
                            </md-table-cell>
                        </md-table-row>
                    </md-table-body>
                </md-table>
            </md-table-card>
            <div v-else>
                <h3 class="not-found  mini-found" v-if="search.isQuery">{{ translate.pages.schedule.index.noResult }} "<strong>{{ search.query }}".</strong></h3>
                <h3 class="not-found  mini-found" v-else>{{ translate.pages.schedule.index.noRecors }}</h3>
            </div>
        </div>
    </div>
</template>
<script>
    import { doctor } from '../../../config/api.js';
    const swal = require('sweetalert2');
    export default {
        data: () => ({
            offices: [],
            real_offices: [],
            search: {
                query: '',
                queryIsDirty: false,
                isCalculating: false,
                isQuery: false
            }
        }),
        created() {
            let url = doctor.api.offices;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get Offices
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.real_offices = JSON.parse(JSON.stringify(data));
                    this.offices = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        computed: {
            // Search indicator
            searchIndicator: function () {
                if (this.search.isCalculating) {
                    return '⟳'
                } else if (this.search.queryIsDirty) {
                    return '...'
                } else {
                    return '✓'
                }
            },
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Path avatar
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            },
            // Sort offices
            onSort(sort) {
                this.offices = _.orderBy(this.offices, [item => item[sort.name]], sort.type);
            },
            // Method to search
            expensiveOperation: _.debounce( function() {
                this.search.isCalculating = true;
                let data = {'query': this.search.query, 'type': 'offices'};
                if(this.search.query == ""){
                    this.offices = JSON.parse(JSON.stringify(this.real_offices));
                    this.search.isCalculating = false;
                    this.search.queryIsDirty = false;
                    this.search.isQuery = false;
                    return;
                } else {
                    var url = doctor.api.search;
                }

                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.post(url, data, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    this.offices = response.data.data;
                    this.search.isCalculating = false;
                    this.search.queryIsDirty = false;
                    this.search.isQuery = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            }, 500),
        },
        watch: {
            'search.query': function () {
                if(this.real_offices.length > 0)
                {
                    this.search.queryIsDirty = true;
                    this.expensiveOperation();
                }else{
                        swal(this.translate.pages.schedule.index.swal.searchQuery.title, this.translate.pages.schedule.index.swal.searchQuery.message, "warning");
                }
            }
        }
    }
</script>
<style scoped>
@media only screen and (min-width: 767px){
    a.icon-detail.icon-schedule {
        position: absolute;
        right: 10px;
    }
}
@media only screen and (min-width: 681px) and (max-width: 767px){
    a.icon-detail.icon-schedule {
        position: absolute;
        right: 10px;
    }
    td.md-table-cell.schedule-detail.md-has-action {
    width: 100%;
}
}

</style>

<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    .Schedule
        .search
            display flex
            padding 1em
            .icon
                text-align center
                width 50px
            .input
                width 100%
                input
                    border 0
                    height 2em
                    width 100%
            .status
                color color_form_placeholder
                font-size 1.5em
                left 0.35em
                position absolute
                top 0.75em
        .table
            padding 3em 2em 2em 2em
            .img
                border-radius 50%
            .name
                margin-left .5em
            .text-center
                text-align center
            .icon-detail
                color color_form_value
                opacity 0.8
                &:hover
                    color color_form_value
                    opacity 1
                    text-decoration none
    @import '../../../assets/styles/responsive.styl'
</style>



// WEBPACK FOOTER //
// Index.vue?16d98c06